/**
 * Accept/reject deadline highlighting for Pending EDI Orders — the colours match the LC
 * Dashboard count severities (CountPanel): <120 min left = yellow, <60 = orange, past due =
 * red. The backend computes the level (in DB time) per result row (`urgency`) and per bucket
 * (`urgency`, the most-urgent among its rows); these helpers just map it to classes.
 */
export type EdiUrgency = '' | 'yellow' | 'orange' | 'red';

const PRIORITY: Exclude<EdiUrgency, ''>[] = ['red', 'orange', 'yellow']; // worst-first

// Count-chip / bucket colours — the same solid tones CountPanel uses.
const CHIP: Record<Exclude<EdiUrgency, ''>, string> = {
  red: 'bg-red-600 text-white',
  orange: 'bg-orange-500 text-white',
  yellow: 'bg-yellow-400 text-black',
};

// Result-row / card tints — the same families, light enough to keep the row text readable.
const ROW: Record<Exclude<EdiUrgency, ''>, string> = {
  red: 'bg-red-100 dark:bg-red-900/30',
  orange: 'bg-orange-100 dark:bg-orange-900/30',
  yellow: 'bg-yellow-100 dark:bg-yellow-900/30',
};

export const urgencyChipClass = (u?: string | null): string =>
  CHIP[(u || '') as Exclude<EdiUrgency, ''>] || '';

export const urgencyRowClass = (u?: string | null): string =>
  ROW[(u || '') as Exclude<EdiUrgency, ''>] || '';

/** Worst (most urgent) level among the given values, or '' when none are urgent. */
export const worstUrgency = (values: (string | null | undefined)[]): EdiUrgency =>
  (PRIORITY.find((p) => values.includes(p)) as EdiUrgency) || '';
